<div class="status-item d-flex justify-content-between align-items-center">
  <strong>{{ header }}</strong>

  <div class="status" [ngSwitch]="status">
    <i *ngSwitchCase="AccountState.Success" class="fas fa-check-circle"></i>
    <i *ngSwitchCase="AccountState.Failed" class="fas fa-times-circle"></i>
    <div *ngSwitchCase="AccountState.Pending" class="status">
      <app-loading-spinner size="md"></app-loading-spinner>
    </div>
  </div>
</div>

<div class="text-danger" *ngIf="status === AccountState.Failed && errorMessage">
  {{ errorMessage }}
</div>
